export const handleAtomProAttachmentClick = (fileName, type) => {
  const urlStart = `https://vider-prod-bucket.s3.ap-south-1.amazonaws.com/`;
  const amazon = type == "AMAZON" || type == null;
  const bharachCloud = type == "BHARATHCLOUD" || type == null;
  const url = amazon
    ? urlStart + fileName
    : bharachCloud
    ? `${fileName["endPoint"]}/${fileName["key"]}`
    : fileName?.key;
  window.open(url);
  // onDoubleClick={() => window.open(data?.webUrl ?? data?.fileUrl)}
};

export const getAtomProFileName = (filePath, type) => {
  // Split the filePath by '/' and get the last part which is the file name
  if (type == "AMAZON" || type == null) {
    const parts = filePath.split("/");
    return parts[parts.length - 1];
  } else if (type == "MICROSOFT" || type == "GOOGLE") {
    const parts = filePath["name"].split("/");
    return parts[parts.length - 1];
  } else if (type == "BHARATHCLOUD") {
    const parts = filePath["key"].split("/");
    return parts[parts.length - 1];
  }
  return null;
};
